import React, { useEffect, useState } from "react";
import { Form, Modal, Row, Col, Spinner, Image } from "react-bootstrap";
import Swal from "sweetalert2";
import xclose from "../../assets/x-close.svg"
import withReactContent from "sweetalert2-react-content";
import Alert from "../common/Alert";
import constants from "../../helpers/constants";
import InputBox from "../common/InputBox";
import FormButtons from "../common/FormButtons";
import { addProductQuantity } from "../../services/product-quantity-service";
import Loader from "../common/loader";
import { validateAlphaNumeric } from "../../helpers/validations";

const ProductQtyForm = (props) => {
    const MySwal = withReactContent(Swal);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [errorMessage, setErrorMessage] = useState();
    const [submit, setSubmit] = useState(false);
    const [fieldCount, setFieldCount] = useState([]);
    const [isFormChanged, setIsFormChanged] = useState(false);
    const [mandatoryFields, setMandatoryFields] = useState([]);

    let action = props.action;

    useEffect(() => {
        setError();
        setErrorMessage()
    }, [props.action])

    const validateDetails = () => {
        let tempError = false;
        for (let errorObj in error) {
            if (error[errorObj]) {
                tempError = true;
                break;
            }
        }

        if (tempError) {
            setErrorMessage("Please check above errors")
        } else {
            setErrorMessage("")
        }
        return tempError;
    }
    const submitForm = (e) => {
        if (isFormChanged) {
            e.preventDefault();
            setSubmit(submit ? false : true);
        }
        else {
            setErrorMessage("No changes in product quantity")
        }
    }

    useEffect(() => {
        let fieldValidation = 7;
        if (fieldCount.length >= fieldValidation) {
            setSubmit(submit ? false : true);
            handleSubmit();
            setFieldCount([]);
        }
    }, [fieldCount, action]);

    const validateQuantity = (value) => {
        let isError = "";
        let pattern = /^[0-9]*$/;
        let regex = new RegExp(pattern);
        if (!regex.test(value)) {
            isError = `Please enter a Valid Number`;
        }
        return isError;
    }

    const handleSubmit = async () => {

        for(let field of Object.keys(productObj)){
            if(/[!@#$%^&*(),.?":{}|<>]/g.test(productObj[field])){
                setErrorMessage("Fields should not contain any special character")
                return
            }
        }

        if (!validateDetails()) {

            let confirmationMessage = "Are you sure do you want to Add New Product Quantity?";
            let title = "Add New Product Quantity";

            MySwal.fire({
                title: title,
                html: confirmationMessage,
                ...constants.CONFIRMATION_BOX_CONFIG
            }).then(async (selection) => {
                if (selection.isConfirmed) {
                    setLoading(true)
                    let result;
                        if (props.productdata.filter((item) => item.productCode?.toLowerCase() === productObj.productCode?.toLowerCase() && item.gadCustomerCode?.toLowerCase() === productObj.gadCustomerCode?.toLowerCase() && item.retailerGstin?.toLowerCase() === productObj.retailerGstin?.toLowerCase()).length > 0) {
                            setErrorMessage("Record with same Product Code, GAD Customer Code and Retailer GSTIN already exists.");
                            setLoading(false);
                            return;
                        }
                    
                    result = addProductQuantity(productObj);
                    result.then((resp) => {
                        Alert("success", "Product Quantity added successfully")
                        props.onHide();
                        props.setReload();
                    }).catch((err) => {
                        setErrorMessage(err);
                        setLoading(false)
                    })
                }
            });
            return
        }
    }


    const [productObj, setProductObj] = useState(
            {
                gadCustomerCode: "",
                retailerGstin: "",
                productCode: "",
                billedQty: "",
                alreadyConsumedQty: "",
                regularConsumedQty: "",
                balanceQty: "",
            }
    );

    const handleReset = () => {
        setProductObj({
            gadCustomerCode: "",
            retailerGstin: "",
            productCode: "",
            billedQty: "",
            alreadyConsumedQty: "",
            regularConsumedQty: "",
            balanceQty: "",
        });
        setIsFormChanged(false);
        setError({});
        setErrorMessage()
        setMandatoryFields(Object.keys(productObj))
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setProductObj((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        setIsFormChanged(true);
    }

    const commonProps = { setError: setError, error: error, submit: submit, setFieldCount: setFieldCount, fieldCount: fieldCount, onChange: handleChange, required: "true", mandatoryFields: mandatoryFields, setMandatoryFields: setMandatoryFields }

    return (
        <>
         {loading && <Loader/>}       
            {/* {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner">
            </Spinner></div>} */}
            <Modal
                {...props}
                size="lg"
                backdrop="static"
                className="productModal"
                enforceFocus={false}
            >
                <Modal.Header >
                    <Image src={xclose} onClick={props.onHide}></Image>
                    <Modal.Title className="modal-title">
                        {action} New Product Quantity
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row >
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="GAD Customer Code" maxLength={50} name="gadCustomerCode" id="gadCustomerCodeID" value={productObj.gadCustomerCode} customValidation= {validateAlphaNumeric} {...commonProps} required />
                        </Col>
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="Retailer GSTIN" maxLength={50} name="retailerGstin" id="retailerGstinID" value={productObj.retailerGstin} customValidation= {validateAlphaNumeric} {...commonProps} required />
                        </Col>
                    </Row>
                    <Row >
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="Product Code" maxLength={50} name="productCode" id="productCodeID" value={productObj.productCode} customValidation= {validateAlphaNumeric} {...commonProps} required />
                        </Col>
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="Billed Quantity" maxLength={50} name="billedQty" id="billedQtyID" value={productObj.billedQty} {...commonProps} required customValidation={validateQuantity}/>
                        </Col>
                    </Row>
                    <Row >
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="Already Consumed Quantity" maxLength={50} name="alreadyConsumedQty" id="alreadyConsumedQtyID" value={productObj.alreadyConsumedQty} {...commonProps} required customValidation={validateQuantity} />
                        </Col>
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="Regular Consumed Quantity" maxLength={50} name="regularConsumedQty" id="regularConsumedQtyID" value={productObj.regularConsumedQty} {...commonProps} required customValidation={validateQuantity} />
                        </Col>
                    </Row>
                    <Row >
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="Balance Quantity" maxLength={50} name="balanceQty" id="balanceQtyID" value={productObj.balanceQty} {...commonProps} required customValidation={validateQuantity} />
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {errorMessage && (
                                <Form.Text className="text-danger">
                                    {errorMessage}
                                </Form.Text>
                            )}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <FormButtons handleReset={handleReset} submitForm={submitForm} action={action} mandatoryFields={mandatoryFields}></FormButtons>
                </Modal.Footer>
            </Modal >

        </>
    );
}

export default ProductQtyForm;
